import {FC, Fragment} from 'react'
import {useUserProfileContext} from '../../../../context/UserProfileContext'

const RecognitionTab: FC = () => {
  const {data} = useUserProfileContext()

  return (
    <div className='recognition-content'>
      <div className='recognition-card'>
        <div className='recognition-section'>
          <div className='recognition-title'>Top Accomplishments</div>
          <div className='recognition-accomplishments'>
            {data?.recognition &&
              data.recognition?.topAccomplishments.map((item:any, index) => {
                return (
                  <Fragment key={`recognation-items-description-${index}`}>
                    <div className='recognition-accomplishment-item'>
                      <div className='recognition-accomplishment-content'>
                      <p>{item?.desc}</p>
                      </div>
                    </div>
                    {index < data?.recognition?.topAccomplishments?.length - 1 && (
                      <div className='recognition-separator' />
                    )}
                  </Fragment>
                )
              })}
          </div>
        </div>
      </div>

      <div className='recognition-card'>
        <div className='recognition-title'>additional Links</div>
        <div className='recognition-links'>
          {data?.recognition &&
            data.recognition?.additionalLinks.map((item, index) => {
              return (
                <div key={`recognation-additional-items-${index}-1`} className='recognition-link-item'>
                  <div className='link-text'><a href={item} target='__blank'>{item}</a></div>
                </div>
              )
            })}
        </div>
      </div>
    </div>
  )
}

export {RecognitionTab}
